import React, { useState, useMemo } from 'react';
import { Box, useTheme } from '@material-ui/core';
import TouchAppIcon from '@material-ui/icons/TouchApp';
import DetailedRulesStyled from './DetailedRulesStyled';
import TooltipsML from '@/components/TooltipsML/TooltipsML';
import PauseCircleFilledIcon from '@material-ui/icons/PauseCircleFilled';
import PlayCircleFilledIcon from '@material-ui/icons/PlayCircleFilled';
import { history } from 'umi';
import { useDispatch, useSelector } from 'dva';
import DialogDataML from '@/components/DialogDataML/DialogDataML';

const DetailedRules = (props) => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const { setModification } = props;
  const crowdDetail = useSelector((state) => state.crowdDetail.crowdDetail); //详情
  const { id, status, title, remark, computeStatus } = crowdDetail || {};

  const [start, setStart] = useState(); //true 启用
  const [calculate, setCalculate] = useState();
  const [calcDisabled, setCalcDisabled] = useState(false);

  const [open, setOpen] = React.useState(false);

  const handleConfirm = () => {
    setOpen(false);
    const computeSta =
      computeStatus === 1 || computeStatus === 2 || computeStatus === 4
        ? 3
        : computeStatus;
    dispatch({
      type: 'crowdDetail/updateComputeStatus',
      payload: {
        values: {
          groupId: id,
          computeStatus: computeSta,
        },
      },
      callback: (res) => {
        if (res.code === 0) {
          // setCalculate(false);
          window.message.toast({
            type: 'success',
            message: '',
            title: '计算中',
          });
          setModification({});
          setCalcDisabled(false);
        } else {
          window.message.toast({
            type: 'error',
            message: res.message,
            title: res.message,
          });
          setCalcDisabled(false);
        }
      },
    });
  };

  const handleClose = () => {
    setOpen(false);
    setCalcDisabled(false);
  };

  // 标签状态 1-启用 2-停用
  useMemo(() => {
    const statusMap = new Map([
      [1, true],
      [2, false],
    ]);
    setStart(statusMap.get(Number(status)));
  }, [status]);

  // 计算状态 1-成功 2-失败 3-计算中 4-等待计算 5-延迟计算
  useMemo(() => {
    const statusMap = new Map([
      [1, true],
      [2, true],
      [3, false],
      [4, false],
      [5, false],
    ]);
    setCalculate(statusMap.get(Number(computeStatus)));
  }, [computeStatus]);

  // 查看规则
  const handleRegular = () => {
    history.push({
      pathname: '/profile/crowd_manage/crowd_detail/rule_detail',
      query: {
        opt: 'detail',
        tagId: id,
      },
    });
  };
  // 暂停/开始
  const handleStart = () => {
    dispatch({
      type: 'crowdDetail/updateGroupStatus',
      payload: {
        values: {
          groupId: Number(id),
          status: start ? 2 : 1,
        },
      },
      callback: (res) => {
        if (res.code === 0) {
          window.message.toast({
            type: 'success',
            message: '',
            title: start ? '暂停成功' : '启动成功',
          });
          setStart(!start);
        } else {
          window.message.toast({
            type: 'error',
            message: res.message,
            title: res.message,
          });
        }
      },
    });
  };

  //计算状态弹窗
  const handleCalculate = () => {
    if (calcDisabled) {
      return;
    }
    setCalcDisabled(true);
    if (computeStatus !== 1 && computeStatus !== 2) {
      return;
    }
    start && setOpen(true);
  };
  // 点击手工计算
  const titleTip = (
    <>
      <span>{remark || '暂无备注'}</span>
      {/* <br />
      <span>更新方式：每日更新</span>
      <br />
      <span>创建者：admin</span>
      <br />
      <span>创建日期：2021-11-03</span>
      <br />
      <span>创建类型：规则标签</span>
      <br />
      <span>品牌：ECCO</span> */}
    </>
  );
  return (
    <DetailedRulesStyled theme={theme} start={start} calculate={calculate}>
      <Box className="detailed_rules">
        <div className="detailed_left">
          <span className="left_bgc"></span>
          <div className="left_content_wrap">
            <span className="tooltip_wrap">
              {title}
              <div className="tooltip_content">
                <TooltipsML title={titleTip} color="#1565C0" isFilled={true} />
              </div>
            </span>
            <div className="content_regular" onClick={() => handleRegular()}>
              <span>查看规则 》</span>
            </div>
          </div>
          <span className="left_content_paly" onClick={() => handleStart()}>
            {start ? (
              <PauseCircleFilledIcon
                className="play_icon"
                sx={{ color: '#fff', fontSize: 47 }}
              />
            ) : (
              <PlayCircleFilledIcon
                className="play_icon"
                sx={{ color: '#fff', fontSize: 47 }}
              />
            )}
          </span>
        </div>
        <div className="detailed_right" onClick={() => handleCalculate()}>
          <TouchAppIcon
            className="band_calculate"
            sx={{
              fontSize: '47',
              color: calculate && start ? '#fff' : '#CCCCCC',
            }}
          ></TouchAppIcon>
          <span>手工计算</span>
        </div>
      </Box>
      <DialogDataML
        open={open}
        title={'手工计算'}
        content={'确定要手工计算吗？'}
        handleClose={handleClose}
        handleConfirm={handleConfirm}
      ></DialogDataML>
    </DetailedRulesStyled>
  );
};

export default DetailedRules;
